import 'video.js/dist/video-js.css';
import { useRouter } from 'next/router';
import { useEffect, useRef, useState } from 'react';

import './CoursesIntroAlternate.scss';
import Transition from '../../../Transition/Transition.jsx';
import icons from '../../../../shared/assets/icons/redesign';
import { trackAction, usePlatform } from '../../../../helpers/tracking';
import CoursesLoginPopup from '../../../CoursesLoginPopup/CoursesLoginPopup.jsx';
import CoursesPlansLegacy from '../CoursesPlansAlternate/CoursesPlansAlternate';
import { isImage } from '../../../../helpers/image';
import { setupCourseSubtitles } from '../../../../helpers/courseSubtitles';

const { Check, ChevronRight } = icons;

const defaultCourseList = [
  {
    name: 'zwangerschapscursus',
    displayName: 'Zwangerschap',
    hasSubtitles: true,
    isBasis: true
  },
  {
    name: 'bevallingscursus',
    displayName: 'Bevalling',
    hasSubtitles: true,
    isBasis: true
  },
  {
    name: 'borstvoedingscursus',
    displayName: 'Borstvoeding',
    hasSubtitles: true,
    isBasis: true
  },
  {
    name: 'zwangerschapsyoga',
    displayName: 'Zwangerschapsyoga',
    hasSubtitles: true,
    isBasis: true
  },
  {
    name: 'sporten-en-bewegen',
    displayName: 'Sporten en bewegen',
    isBasis: true
  },
  {
    name: 'voedingscursus',
    displayName: 'Voeding',
    hasSubtitles: true,
    isBasis: true
  },
  {
    name: 'snelcursus-voor-de-partner',
    displayName: 'Snelcursus voor de partner',
    hasSubtitles: true,
    isBasis: true
  },
  {
    name: 'hypnobirthing',
    displayName: 'Introductie in HypnoBirthing®',
    isBasis: true
  },
  {
    name: 'seksualiteit-tijdens-en-na-de-zwangerschap',
    displayName: 'Seksualiteit tijdens en na de zwangerschap',
    isBasis: true
  },
  {
    name: 'herstel-na-de-bevalling-sep',
    displayName: 'Herstel na de bevalling',
    isBasis: true
  },
  {
    name: 'de-eerste-100-dagen-na-de-bevalling',
    displayName: 'De eerste 100 dagen na de bevalling',
    isBasis: true
  },
  {
    name: 'mindfulnesscursus',
    displayName: 'Mindfulness zwangerschap'
  },
  {
    name: 'dragen-en-hechting',
    displayName: 'Dragen en hechting'
  },
  {
    name: 'babymassage',
    displayName: 'Babymassage',
    hasSubtitles: true
  },
  {
    name: 'babysignalen-en-baby-en-kinder-gebaren',
    displayName: 'Babysignalen en baby en kinder gebaren'
  },
  {
    name: 'slaapcursus0-6maanden',
    displayName: 'Slaapcursus 0-6 maanden'
  },
  {
    name: 'slaapcursus-pakket',
    displayName: 'Slaapcursus 6 maanden tot 5 jaar'
  },
  {
    name: 'mindfulness-na-bevalling',
    displayName: 'Mindfullness na de bevalling'
  }
];

export default function CoursesIntro({
  list = [],
  config,
  user,
  hideIntro,
  courseList = defaultCourseList,
  plans,
  addUserEvent
}) {
  const router = useRouter();
  const platform = usePlatform();
  const [popup, showPopup] = useState(false);

  return (
    <div className="coursesIntroAlternate">
      <Transition on={popup}>
        <CoursesLoginPopup
          config={config}
          showPopup={showPopup}
          customList={[
            '18 meest populaire cursussen',
            'ruim 1500 min. aan professionele video’s',
            '(deels) vergoed door je zorgverzekeraar'
          ]}
        />
      </Transition>

      {!hideIntro && (
        <>
          <h1 className="coursesIntroAlternate-title">
            Volg jouw (zwangerschaps)cursus nu lekker vanuit huis!
          </h1>

          <p className="coursesIntroAlternate-text">
            Volg jouw (zwangerschaps)cursus nu lekker vanuit huis!
            <br />
            Een compleet cursusportaal waar je zowel zwangerschaps-, beval- en
            babycursussen krijgt? Het bestaat. Met momenteel 18 cursussen zorgen
            onze professionals ervoor dat jij en je partner alles aankunnen wat
            er op jullie pad komt tijdens en na de zwangerschap. Leer alles wat
            je wilt weten en volg de cursus op jouw moment, in jouw veilige
            thuisomgeving.
          </p>

          <h3 className="coursesIntroAlternate-subtitle">Het cursusportaal:</h3>

          <ul className="coursesIntroAlternate-list">
            <li className="coursesIntroAlternate-list-item">
              <div className="coursesIntroAlternate-list-item-icon-wrap">
                <Check className="coursesIntroAlternate-list-item-icon" />
              </div>
              18 meest populaire cursussen
            </li>

            <li className="coursesIntroAlternate-list-item">
              <div className="coursesIntroAlternate-list-item-icon-wrap">
                <Check className="coursesIntroAlternate-list-item-icon" />
              </div>
              ruim 1500 min. aan professionele video’s
            </li>

            <li className="coursesIntroAlternate-list-item">
              <div className="coursesIntroAlternate-list-item-icon-wrap">
                <Check className="coursesIntroAlternate-list-item-icon" />
              </div>
              (deels) vergoed door je zorgverzekeraar
            </li>
          </ul>

          <div className="coursesIntroAlternate-text-small">
            <img
              alt="courses-users"
              src="https://upr.io/dBEyMP.png"
              className="coursesIntroAlternate-img"
            />

            <p>
              Maartje en
              <span className="coursesIntroAlternate-text-bold">
                {' '}
                {calculateCoursesMemberCount()} anderen{' '}
              </span>
              hebben toegang tot cursussen.
            </p>
          </div>

          <h3 className="coursesIntroAlternate-subtitle">Wat onze cursisten zeggen:</h3>

          <ul className="coursesIntroAlternate-review-list">
            <li className="coursesIntroAlternate-review-list-item">
              <p>
                Zwangerschapscursus
                <br />
                <span>9.5</span>
              </p>
              <q>Geweldige cursus. En helemaal gratis!</q>
            </li>

            <li className="coursesIntroAlternate-review-list-item">
              <p>
                Bevallingscursus
                <br />
                <span>8.0</span>
              </p>
              <q>Informatief, prettig om naar te kijken</q>
            </li>

            <li className="coursesIntroAlternate-review-list-item">
              <p>
                Borstvoedingscursus
                <br />
                <span>8.3</span>
              </p>
              <q>Fijn overzicht</q>
            </li>

            <li className="coursesIntroAlternate-review-list-item">
              <p>
                Snelcursus voor de partner
                <br />
                <span>8.1</span>
              </p>
              <q>
                Heel fijn om deze cursussen samen met mijn partner te bekijken
              </q>
            </li>

            <li className="coursesIntroAlternate-review-list-item">
              <p>
                Seksualiteit tijdens en na de zwangerschap
                <br />
                <span>8.3</span>
              </p>
              <q>Doorbreekt taboe en dat is prettig</q>
            </li>
          </ul>
        </>
      )}

      <h2 className="coursesIntroAlternate-subtitle">
        Kies het pakket wat bij jou past:
      </h2>

      <CoursesPlansLegacy
        user={user}
        plans={plans}
        showPopup={showPopup}
        courseList={courseList}
        addUserEvent={addUserEvent}
      />

      <button
        onClick={() => {
          router.push('/verzekering/cursus-vergoeding');

          trackAction(
            platform,
            'courseswelkom',
            'clickinsurancereimbursementbutton'
          );
        }}
        className="coursesIntroAlternate-button coursesIntroAlternate-button-secondary"
      >
        Vergoedt mijn verzekering?
      </button>

      <ul className="coursesIntroAlternate-video-list">
        {courseList.map((course) => {
          const { displayName, name, courseModules, userImageUrl, username } =
            list.find(({ name }) => course.name === name) || {};

          if (!name) return;

          const introductionVideo =
            courseModules.find(
              (module) => module.name === 'Introductievideo'
            ) || {};

          return (
            <li key={name} className="coursesIntroAlternate-video-list-item" id={name}>
              <div className="coursesIntroAlternate-video-list-item-header">
                {displayName}

                {!isImage(introductionVideo.url) && (
                  <a
                    className="coursesIntroAlternate-video-list-item-header-link"
                    href={`/zwangerschapscursus/${name}/${
                      name === 'bevallingscursus'
                        ? 'introductievideobevalingscursus'
                        : 'introductievideo'
                    }`}
                  >
                    Lees meer{' '}
                    <ChevronRight className="coursesIntroAlternate-video-list-item-header-link-icon icon" />
                  </a>
                )}
              </div>

              <div className="coursesIntroAlternate-video-list-item-body">
                {isImage(introductionVideo.url) ? (
                  <img
                    src={introductionVideo.url}
                    alt="course-image"
                    className="coursesIntroAlternate-video-list-item-img"
                  />
                ) : (
                  <VideoItem item={introductionVideo} list={list} />
                )}

                <div className="coursesIntroAlternate-video-list-item-info">
                  <span>Introductie</span>

                  <div className="coursesIntroAlternate-video-list-item-author">
                    <img
                      className="coursesIntroAlternate-video-list-item-author-image"
                      src={userImageUrl}
                      alt="course-author-image"
                    />
                    <span className="coursesIntroAlternate-video-list-item-author-name">
                      {username}
                    </span>
                  </div>
                </div>
              </div>
            </li>
          );
        })}
      </ul>
    </div>
  );
}

function VideoItem({ item }) {
  const playerRef = useRef();
  const subtitleKey = Array.isArray(item?.subtitles)
    ? item.subtitles.join(',')
    : '';

  useEffect(() => {
    let cancelled = false;

    (async () => {
      const videojs = (await import('video.js')).default;

      if (cancelled || !playerRef.current) return;
      if (playerRef.current.classList.contains('vjs-tech')) return;

      const player = videojs(playerRef.current, {
        fluid: true,
        controls: true,
        sources: [{ src: item.url, type: 'video/mp4' }],
        playbackRates: [0.5, 1, 1.5, 2],
        html5: { nativeTextTracks: false }
      });

      player.ready(() => {
        if (cancelled) return;

        setupCourseSubtitles(
          player,
          videojs,
          item.url,
          subtitleKey ? subtitleKey.split(',') : []
        );
      });
    })();

    return () => {
      cancelled = true;
    };
  }, [item.url, subtitleKey]);

  return (
    <div className="coursesIntroAlternate-video-list-item-video">
      <div data-vjs-player>
        <video ref={playerRef} className="video-js" />
      </div>
    </div>
  );
}

function calculateCoursesMemberCount() {
  const initialDateToTrackCoursesMemberCount = new Date('2023-02-11');

  const differenceInDays = Math.ceil(
    (new Date().getTime() - initialDateToTrackCoursesMemberCount.getTime()) /
      (1000 * 3600 * 24)
  );

  return (7891 + differenceInDays * 3).toLocaleString('nl-NL');
}
